import axios from "axios";
import services from ".";
import jwtDecode from "jwt-decode";
import globals from "../globlas";

const APIROOT = globals.REACT_APP_URL_BASE_API;

axios.interceptors.request.use(
  async function (config) {
    let newConfig = {
      ...config,
      headers: {
        ...config.headers,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
        // Removidos headers que o navegador não permite definir manualmente:
        // 'sec-ch-ua', 'sec-ch-ua-mobile', 'sec-ch-ua-platform', 'User-Agent'
      }
    };

    try {
      let token = sessionStorage.getItem("authSistema");

      if (token) {
        try {
          let tokenDecode = jwtDecode(token);

          if (token && tokenDecode) {
            let isExpired = _isExpired(tokenDecode.exp);

            if (isExpired) {
              services.storage.clear();
              window.open(window.location.hostname);
            }

            newConfig.headers = {
              ...newConfig.headers,
              Authorization: `Bearer ${token}`,
            };
          }
        } catch (jwtError) {
          console.error('Erro ao decodificar token:', jwtError);
          services.storage.clear();
          window.open(window.location.hostname);
        }
      }
      return newConfig;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

const _isExpired = (dataEx) => {
  let dataExformat = dataEx * 1000;
  if (Date.now() >= dataExformat) {
    return true;
  }
  return false;
};

export const _sendWithAxiosProgress = async (url, method, payload, options) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
      onUploadProgress: (event) => {
        options(event.loaded, event.total);
      },
    });

    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

export const _sendWithAxios = async (url, method, payload) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
    });

    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};
export const _paramsWithAxios = async (url, method, payload, responseType) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      params: payload,
      responseType,
    });

    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

export const _sendWithAxiosBlob = async (url, method, payload) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      responseType: "blob",
      data: payload,
    });
    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

const _parseError = (error) => {
  let errors = [];
  const { response, isAxiosError } = error;
  if (response && response.data) {
    const { data } = response;
    errors = data || [];
  } else if (isAxiosError) {
    errors.push({ message: "Falha ao enviar dados ao servidor" });
  }
  return errors;
};

////// geral
export const logar = async (acessParams) => {
  return await _sendWithAxios(`${APIROOT}login`, "POST", acessParams);
};
export const resetarSenha = async (email) => {
  let obj = { email: email };
  return await _sendWithAxios(`${APIROOT}usuario/senha/resetar`, "POST", obj);
};

export const marcarSessao = async() => {
  return await _sendWithAxios(`${APIROOT}AutenticarUsuario/marcar-sessao`, "POST");
};

export const alterarSenha = async (dados) => {
  return await _sendWithAxios(`${APIROOT}usuario/senha/alterar`, "POST", dados);
};
